import { useAct } from 'FlowTaker/store'
import FundraiseUpForm from 'FlowBuilder/components/ActionViews/FundraiseUp/FundraiseUpForm'
import TemplateRender from 'FlowBuilder/components/ActionViews/TemplateRender'
import useRenderContext from 'FlowTaker/hooks/useRenderContext'

export default function FundraiseUpAction({ actionId }) {
  const act = useAct()
  const bodyHtml = useSel(s => s.taker.flow.template.body)
  const context = useRenderContext({ actionId })
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})

  const handleSubmit = () => {
    return act.taker.completeAction({ actionId })
  }

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <FundraiseUpForm
        action={action}
        onSubmit={handleSubmit}
      />
    </>,
  }), [])

  return <div>
    <TemplateRender htmlContent={bodyHtml} componentMap={componentMap} context={context} />
  </div>
}
